import { Category, Manufacturer } from '@/services/api/contracts/catalog/types';
import { Region } from '@/services/api/contracts/region';
import { useMemo } from 'react';
import { Result } from '../steps/UploadFinanceModelStep';
import { BULK_FINANCE_MODEL_PERIPHERAL_CATEGORY_ID } from './utils';

export const getMismatchedManufacturers = (result: Result, manufacturers: Manufacturer[]) => {
  const unique = new Set(result.data.filter(item => item.Manufacturer).map(p => p.Manufacturer));
  return [...unique].filter(m => !manufacturers.find(manufacturer => manufacturer.name === m));
};

export const useMismatchedManufacturers = (result: Result, manufacturers: Manufacturer[]) => {
  return useMemo(() => getMismatchedManufacturers(result, manufacturers), [result, manufacturers]);
};

export const getMismatchedCategories = (result: Result, categories: Category[]) => {
  const unique = new Set(
    result.data
      .filter(item => item.Category.toLowerCase() !== BULK_FINANCE_MODEL_PERIPHERAL_CATEGORY_ID)
      .map(p => p.Category)
  );
  return [...unique].filter(m => !categories.find(category => category.name === m));
};

export const useMismatchedCategories = (result: Result, categories: Category[]) => {
  return useMemo(() => getMismatchedCategories(result, categories), [result, categories]);
};

export const getMismatchedRegions = (result: Result, regions: Region[]) => {
  const unique = new Set(result.data.flatMap(p => p.Pcms.map(r => r.type)));
  return [...unique].filter(m => !regions.find(region => region.code === m));
};

export const useMismatchedRegions = (result: Result, regions: Region[]) => {
  return useMemo(() => getMismatchedRegions(result, regions), [result, regions]);
};
